<template>
    <a-button
        class="map-icon-btn"
        :loading="loading"
        title="Ir para o Aplicativo"
        aria-label="Ir para o Aplicativo"
        @click="returnToApp"
    >
        <template #icon>
            <MobileOutlined class="menu-icon" />
        </template>
    </a-button>
</template>

<script setup>
import { ref } from 'vue'
import { MobileOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'

const loading = ref(false)

async function returnToApp() {
    if (loading.value) return

    loading.value = true
    try {
        const { data } = await window.axios.post('/api/auth/app-session')
        const redirectTo = data?.redirect_to || data?.data?.redirect_to

        if (!redirectTo) {
            message.error('Não foi possível ir para o aplicativo.')
            return
        }

        window.location.href = redirectTo
    } catch {
        message.error('Não foi possível ir para o aplicativo.')
    } finally {
        loading.value = false
    }
}
</script>

<style scoped>
.map-icon-btn {
    width: var(--home-map-icon-size, 32px);
    height: var(--home-map-icon-size, 32px);
    border-radius: var(--home-map-icon-radius, 6px);
    background-color: rgba(0, 60, 136, 0.6);
    color: white;
    border: 2px solid white;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.map-icon-btn:hover {
    background-color: rgba(0, 60, 136, 0.7);
}

.menu-icon {
    color: white;
    font-size: var(--home-map-icon-glyph-size, 16px);
}
</style>
